import type { CSSProperties, ImgHTMLAttributes } from "react";

type CastieroLoginProps = ImgHTMLAttributes<HTMLImageElement> & {
  transform?: string;
};

const CastieroLogin = ({
  style,
  transform,
  alt = "Castiero",
  ...props
}: CastieroLoginProps) => (
  <img
    {...props}
    alt={alt}
    src="/logo-castiero.png"
    style={{
      objectFit: "contain",
      transform,
      ...(style as CSSProperties | undefined),
    }}
  />
);

export default CastieroLogin;
